// 课程状态
export default {
    LESSON_STATUS_UNPAID: -1, // 未购买
    LESSON_STATUS_NEW: 0, // 已购买未作业
    LESSON_STATUS_WAITING: 50, // 训练营暂缓开课
    LESSON_STATUS_COMPLETE: 100, // 已作业
    LESSON_STATUS_TIMEOUT: 200, // 超时锁定
};